module.exports = __webpack_public_path__ + "img/ic_dianxiaomi_logo_normal.de652ca.png";